import Service from "../Service";
import Vue from "vue";
const resource = "TasProducerOldDebts/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID },
        });
    },
    save(TasProducerOldDebts, requestID) {
        return Service.post(resource + "save", TasProducerOldDebts, {
            params: { requestID },
        });
    },

    saveList(cmp, requestID) {

        return Service.post(resource + "saveList", cmp, {
            params: { requestID: requestID },
        });
    },

}